
import { WINDOW } from "AtomicUtils/environment"

const checkVisible = (element) => {
  if (!element || !WINDOW) return false
  const rect = element.getBoundingClientRect();
  const viewHeight = Math.max(WINDOW.document.documentElement.clientHeight, WINDOW.innerHeight) + 200;
  if (Math.abs(rect.top) <= viewHeight ) return true
  if (Math.abs(rect.bottom) <= viewHeight ) return true
  return false
}

export default checkVisible



// WEBPACK FOOTER //
// ./src/AtomicUtils/checkVisible.js